import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { Token } from '@/domain/types/Token'
import { Address } from 'viem'

// Canonical Permit2 address (same on all chains)
export const PERMIT2_ADDRESS = '0x000000000022D473030F116dDEE9F6B43aC78BA3' as const

export interface Permit2SignObjective {
  type: 'permit2Sign'
  token: Token
  amount: NormalizedUnitNumber
  spender: Address // vault that will use the permit
}

export interface Permit2SignAction {
  type: 'permit2Sign'
  token: Token
  amount: NormalizedUnitNumber
  spender: Address
}
